import { ProspectStatuses } from "@constants/ProspectStatuses";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import MultipleSelectorWithCount from "../multiple-selector-with-count/MultipleSelectorWithCount";
import { messages } from "./messages.i18n";
const ProspectSelector = ({ updateSelectedProspects, selectedProspectStatuses }) => {
    const intl = useIntl();
    const inactiveItemsIndexes = useMemo(() => {
        if (selectedProspectStatuses.includes(ProspectStatuses.ALL)) {
            return [1, 2];
        }
        else if (selectedProspectStatuses.includes(ProspectStatuses.IDENTIFIED)) {
            return [2];
        }
        return [];
    }, [selectedProspectStatuses]);
    return (React.createElement(MultipleSelectorWithCount, { items: Object.values(ProspectStatuses), selectedItems: selectedProspectStatuses, setItems: updateSelectedProspects, label: intl.formatMessage(messages.prospectStatusSelectorLabel), inactiveItemsIndexes: inactiveItemsIndexes }));
};
export default ProspectSelector;
